import { THEMES, } from './config';
import { darkMobileTheme } from './dark-mobile';
import { lightMobileTheme } from './light-mobile';
import { adjustOpacity } from "./colors";
export * from './config';
const themeTypes = {
    [THEMES.LIGHT_MOBILE]: lightMobileTheme,
    [THEMES.DARK_MOBILE]: darkMobileTheme,
};
const ThemeProvider = () => {
    let _theme;
    let _initialized = false;
    const initialize = (type, color, sColor) => {
        if (!_initialized) {
            _theme =
                themeTypes[type] ||
                    themeTypes[THEMES.DARK_MOBILE];
            /*** dynamically changing primary color ***/
            if (color) {
                _theme.colors.Primary_100 = adjustOpacity(color, 1);
                _theme.colors.Primary_02 = adjustOpacity(color, 0.02);
                _theme.colors.Primary_05 = adjustOpacity(color, 0.05);
                _theme.colors.Primary_10 = adjustOpacity(color, 0.10);
                _theme.colors.Primary_20 = adjustOpacity(color, 0.20);
            }
            if (sColor) {
                _theme.colors["Secondary/100"] = adjustOpacity(sColor, 1);
                _theme.colors["Secondary/02"] = adjustOpacity(sColor, 0.02);
                _theme.colors["Secondary/05"] = adjustOpacity(sColor, 0.05);
                _theme.colors["Secondary/10"] = adjustOpacity(sColor, 0.10);
                _theme.colors["Secondary/20"] = adjustOpacity(sColor, 0.20);
            }
            _initialized = true;
        }
    };
    const getTheme = () => {
        if (_initialized) {
            return _theme;
        } // console.warn('Theme not initialized');
        return themeTypes[THEMES.DARK_MOBILE];
    };
    return {
        init: initialize,
        getTheme,
    };
};
export default ThemeProvider();
